import { render, staticRenderFns } from "./IconsToReviewList.vue?vue&type=template&id=e6a2cff8&scoped=true"
import script from "./IconsToReviewList.vue?vue&type=script&lang=js"
export * from "./IconsToReviewList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a2cff8",
  null
  
)

export default component.exports